import { useEffect, useState } from 'react';

import isClient from 'commons/isClient';
import setHttpContextValue from 'commons/setHttpContextValue';
import getHttpContextValue from 'commons/getHttpContextValue';
import isNewConsumerApp from 'commons/isNewConsumerApp';

const CONTEXT_KEY = 'useIsomorphicEffectState';

const getPrevDeps = id => {
  const effectState = getHttpContextValue(CONTEXT_KEY) || {};
  return effectState[id] || [];
};

const setPrevDeps = (id, deps) => {
  const effectState = getHttpContextValue(CONTEXT_KEY) || {};
  effectState[id] = deps;
  setHttpContextValue(CONTEXT_KEY, effectState);
};

const useIsomorphicEffectOld = (create, deps, caller) => {
  const [randomId] = useState(Math.random());
  const id = caller ?? randomId;

  if (isClient()) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(create, deps);
    return;
  }

  let hasChanged = false;
  const prevDeps = getPrevDeps(id);
  for (let i = 0; i < deps.length; i++) {
    if (prevDeps?.[i] !== deps?.[i]) {
      hasChanged = true;
      break;
    }
  }
  if (!hasChanged) {
    return;
  }
  create();
  setPrevDeps(id, deps);
};

// In new consumer app, just use useEffect directly
const useIsomorphicEffect = isNewConsumerApp
  ? useEffect
  : useIsomorphicEffectOld;

export default useIsomorphicEffect;
